export default "__VITE_ASSET__3351e59d__"